import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import { Mesh, TextureLoader } from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { FontLoader } from 'three/src/loaders/FontLoader.js'
import { AnimationMixer } from 'three/src/animation/AnimationMixer.js'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import gsap from 'gsap'

    // document.getElementById('loading').style.display = "visible";
    // document.querySelector('canvas').style.visibility = "hidden";
    document.getElementById('loading').classList.add('active');
    document.querySelector('canvas').classList.add('inactive');
    // document.getElementById('content').style.visibility = "hidden";

// SLIDES
        let slideIndex = 1;
        let which = 0;
        // showSlides(slideIndex, which);

        function plusSlides(n) {
            showSlides(slideIndex += n);
        }

        function currentSlide(n) {
            showSlides(slideIndex = n);
        }

        function showSlides(n) {
            let i;
            let slides1 = document.getElementsByClassName('mySlides1');
            let slides2 = document.getElementsByClassName('mySlides2');
            let slides3 = document.getElementsByClassName('mySlides3');
            let slides4 = document.getElementsByClassName('mySlides4');
            let slides5 = document.getElementsByClassName('mySlides5');
            let slides6 = document.getElementsByClassName('mySlides6');
            let slides7 = document.getElementsByClassName('mySlides7');
            let slides8 = document.getElementsByClassName('mySlides8');
            let slides9 = document.getElementsByClassName('mySlides9');
            

            let dots = document.getElementsByClassName("demo");
            if (n > 5) {
                slideIndex = 1
            }
            if (n < 1) {
                slideIndex = 5
            }
            for (i = 0; i < 5; i++) {
                slides1[i].style.display = "none";
                slides2[i].style.display = "none";
                slides3[i].style.display = "none";
                slides4[i].style.display = "none";
                slides5[i].style.display = "none";
                slides6[i].style.display = "none";
                slides7[i].style.display = "none";
                slides8[i].style.display = "none";
                slides9[i].style.display = "none";

            }
            for (i = 0; i < dots.length; i++) {
                dots[i].className = dots[i].className.replace(" active", "");
            }
            slides1[slideIndex - 1].style.display = "block";
            slides2[slideIndex - 1].style.display = "block";
            slides3[slideIndex - 1].style.display = "block";
            slides4[slideIndex - 1].style.display = "block";
            slides5[slideIndex - 1].style.display = "block";
            slides6[slideIndex - 1].style.display = "block";
            slides7[slideIndex - 1].style.display = "block";
            slides8[slideIndex - 1].style.display = "block";
            slides9[slideIndex - 1].style.display = "block";

            dots[slideIndex - 1].className += " active";
        }
        

        // document.getElementById('prevButton').addEventListener('click', (e) => {
        //     plusSlides(-1);
        //     console.log('click prev');
        // }); 
        // document.getElementById('nextButton').addEventListener('click', (e) => {
        //     plusSlides(1);
        //                 console.log('click next');

        // }); 

        for(let i = 1; i <= 45; i++){

            console.log('curr demo', i)
            document.getElementById(`demo${i}`).addEventListener('click', (e) => {
                console.log('current click', i);
                currentSlide(i%5);
            });
        }
         

// LOADING
jQuery(window).load(function () {
    // document.getElementById('loading').style.display = "none";
    document.getElementById('loading').classList.add('inactive');
    document.getElementById('loading').classList.remove('active');
    document.getElementById('loading').style.visibility = "hidden";
    document.getElementById('loading').style.display = "none";
    // document.getElementById('content').style.visibility = "visible";


    document.querySelector('canvas').classList.remove('inactive');

    document.querySelector('canvas').classList.add('active');

    document.querySelector('canvas').style.visibility = "visible";

    setTimeout(function () {
        console.log('page is loaded and 1 minute has passed');   
    }, 60000);

});

// ------------------------       THREE JS      -------------------------------
let camera, scene, renderer, mixer, load;
let objs = []

// Canvas
const canvas = document.querySelector('canvas.canvasGL')

let sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
init();
onWindowResize();

function init() {
    // Scene
    scene = new THREE.Scene()
    const texLoad = new THREE.TextureLoader();

    // Base camera
    camera = new THREE.PerspectiveCamera(85, sizes.width / sizes.height, 1, 10000)
    camera.position.x = 0
    camera.position.y = 0
    camera.position.z = 7;
    scene.add(camera)

    //Modeling light
    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
    hemiLight.position.set(0, 300, 0);
    scene.add(hemiLight);

    const dirLight = new THREE.DirectionalLight(0xffffff);
    dirLight.position.set(75, 300, -75);
    scene.add(dirLight);

    const geo_cube = new THREE.BoxGeometry( 1, 1, 1 );
    // const mat_cube = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    
    // PACKAGES
    // const loader = new GLTFLoader();
    // let mod;
    // let mods = [];

    // for (let i = 1; i <= 8; i++) {
    //     loader.load('3d/sofa.glb',
    //     function(gltf) {
    //         mod = gltf.scene;
    //         mod.position.z = 4;
    //         mod.position.x = (i*2) -6;
    //         mod.position.y = 0;
    //         mod.rotation.y = -Math.PI/2;
    //         mod.scale.set(1,1,1);

    //         mixer = new THREE.AnimationMixer(mod);
    //         console.log('Loaded GLTF', mod);

    //         // animate()
    //         console.log('3d loaded');
    //         scene.add(mod);

    //     },
    //     // called while loading is progressing
    //     function(xhr) {
    //         console.log((xhr.loaded / xhr.total * 100) + '% 3D model loaded');
    //         if (xhr.loaded / xhr.total == 1) {
    //             console.log('trigger loaded',document.getElementById('loading').style);
    //             // document.querySelector('canvas').style.visibility = "visible";

    //         } else {
    //             // document.querySelector('canvas').style.visibility = "hidden";
    //         }
    //     },
    //     // called when loading has errors
    //     function(error) {
    //         alert('error');
    //         console.log('An error happened????');

    //     });
    // }

    //IMAGES 
    const geo = new THREE.PlaneBufferGeometry(1, 1);
    for (let i = 1; i <= 11; i++) {
        const mat = new THREE.MeshBasicMaterial({
            map: texLoad.load(`../photo/${i}.png`)
        })
        const mat_cube = new THREE.MeshBasicMaterial({
            map: texLoad.load(`../photo/${i}.png`)
        })

        // const img = new THREE.Mesh(geo, mat)
        // img.position.x += (i * 2) - 6;
        // img.position.z += 3.6;
        // img.rotation.y += 1

        const cube = new THREE.Mesh( geo_cube, mat_cube );
        cube.position.x += (i*2.5) -6;
        cube.position.z += 3.4;
        cube.rotation.y += 1
        scene.add( cube );

        // scene.add(img)
    }



    scene.traverse((object) => {
        console.log('list object', object);
        if (object.isMesh) {
            objs.push(object)
            console.log('Mesh Array', objs)
        }
    })

   

    // Materials
    const material = new THREE.MeshBasicMaterial({})
    material.color = new THREE.Color(0xff00ff)
    material.transparency = true;


    //Renderer
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true,
    })
    renderer.setSize(sizes.width, sizes.height)
    document.body.appendChild(renderer.domElement);

    //Controls
    // const controls = new OrbitControls(camera, renderer.domElement); //renderer dom element is canvas
    // controls.target.set(0, 0, 0);
    // controls.update();

    // controls.addEventListener('change', render);

    //Window Size
    window.addEventListener('resize', onWindowResize);

    render();
}



function onWindowResize() {
    //Size 
    window.addEventListener('resize', () => {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })

    render();
}

function render() {
    renderer.render(scene, camera);
}



document.addEventListener('wheel', onMouseWheel)

let mouseX = 0;
let mouseY = 0;
let targetX = 0;
let targetY = 0;
let windowX = window.innerWidth / 4;
let windowY = window.innerHeight / 4;

function onMouseWheel(event) {
    // mouseX = (event.clientX - windowX)
    // mouseY = (event.clientY - windowY)
    mouseY = event.deltaY * 0.01
}

const mouse = new THREE.Vector2()
document.addEventListener('mousemove', onMouseMove)

function onMouseMove(event) {
    mouse.x = (event.clientX / sizes.width) * 2 - 1
    mouse.y = (event.clientY / sizes.height) * 2 - 1
}

const clock = new THREE.Clock()
let posZ = 0;

const raycaster = new THREE.Raycaster()
let intChild = raycaster.intersectObjects(scene.children);

// window.addEventListener('pointerdown', menuClick, false);
$('body').on('pointerdown', menuClick);


// Exit
document.getElementById('back').addEventListener('click', (e) => {
    //Enable clicking again
    $('body').on('pointerdown', menuClick);
    document.getElementById('copyright').style.display="block";

    document.getElementById('item1').style.display ="none";
    document.getElementById('item2').style.display ="none";
    document.getElementById('item3').style.display ="none";
    document.getElementById('item4').style.display ="none";
    document.getElementById('item5').style.display ="none";
    document.getElementById('item6').style.display ="none";
    document.getElementById('item7').style.display ="none";
    document.getElementById('item8').style.display ="none";
    document.getElementById('item9').style.display ="none";
    // document.getElementById('prevButton').style.display = "none";
    // document.getElementById('nextButton').style.display = "none";
    document.getElementById('back').style.display = "none";


    console.log('clicked back');
})




//clicking menu check
let clicked = false;
function menuClick(event) {
        clicked = true;
    console.log('clicked?', clicked);
    raycaster.setFromCamera(mouse, camera);

    let intersects = raycaster.intersectObjects(scene.children);

    for (const intersect of intersects) {
        for (const object of objs) {
            if (intersect.object == objs[0] && clicked == true) {
                $('body').off('click');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item1').style.display = "block";

                document.getElementById('back').style.display = "block";

                clicked = false;
                showSlides(slideIndex);
                console.log('show menu 1', document.getElementById('item1').style.display)
                

            } else if (intersect.object == objs[1] && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item2').style.display = "block";

                document.getElementById('back').style.display = "block";

                console.log('show menu 2')


            } else if (intersect.object == objs[2]  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item3').style.display = "block";

                document.getElementById('back').style.display = "block";

                console.log('show menu 3')


            } else if (intersect.object == objs[3]  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item4').style.display = "block";                

                document.getElementById('back').style.display = "block";

                console.log('show menu 4')


            }
            else if (intersect.object == objs[4]  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');

                document.getElementById('copyright').style.display="none";

                document.getElementById('item5').style.display = "block";

                document.getElementById('back').style.display = "block";

                console.log('show menu 5')


                // window.open('http://www.discord.com/');
            } else if ((intersect.object == objs[5])  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');

                document.getElementById('copyright').style.display="none";

                document.getElementById('item6').style.display = "block";

                document.getElementById('back').style.display = "block";


                console.log('show menu 6')

            } else if ((intersect.object == objs[6])  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item7').style.display = "block";

                document.getElementById('back').style.display = "block";



            } else if ((intersect.object == objs[7])  && clicked == true) {
                clicked = false;
                showSlides(slideIndex);
                $('body').off('pointerdown');
                document.getElementById('copyright').style.display="none";

                document.getElementById('item8').style.display = "block";

                document.getElementById('back').style.display = "block";

            }
            else if ((intersect.object == objs[8])  && clicked) {
                clicked = false;

                showSlides(slideIndex);
                document.getElementById('copyright').style.display="none";

                document.getElementById('item9').style.display = "block";
                $('body').off('pointerdown');

                document.getElementById('back').style.display = "block";
            }
        }
    }
}


// const over = document.getElementById('overlay');
// over.addEventListener('click', function(event) {
//     console.log('clicked outside menu');
//     document.getElementById('popup').classList.remove('active');
//     // document.getElementById('overlay').classList.remove('active');
// })

function tick() {

    const delta = clock.getDelta() //delta has to be initialized before elapsedTime

    const elapsedTime = clock.getElapsedTime();

    if(camera.position.x < 10){
        camera.position.x += 0.005;
    }

    // else if(camera.position.x == 10){
    //     camera.position.x = 10;

    // }
    let zoom = 0;
    // Raycaster for rotation
    raycaster.setFromCamera(mouse, camera);

    let intersects = raycaster.intersectObjects(objs);

   

    for (const intersect of intersects) {
        gsap.to(intersect.object.scale, { x: 3, y: 3, z: 0.00001 });
        gsap.to(intersect.object.rotation, { y: 0 })
        
    }

    for (const object of objs) {
        if (!intersects.find(intersect => intersect.object === object)) {
            gsap.to(object.scale, { x: 2, y: 2, z: 0.00001 })
            gsap.to(object.rotation, { y: -0.5 })
        }
    }


    if (mixer) {
        mixer.update(delta);
    }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

function moveMenu(loc) {
    camera.position.x += loc;
}
//get navbar
// let navs = [...document.getElementsByClassName('nav')];
// console.log('NAVS', navs);
// navs.forEach((nav, i) => {
//     let m = new THREE.MeshBasicMaterial();
//     m.color = new THREE.Color(0xffffff)
//         // m.texture = new THREE.Texture(nav);
//     let g = new THREE.PlaneBufferGeometry(1.5, 1);
//     let msh = new THREE.Mesh(g, m)
//     scene.add(msh)

//     msh.position.y = i * 1.2;

// })

// JS
let speedMouse = 0;
let speedMobile = 0;
let lastY, currY;

window.addEventListener('wheel', scroll);

window.addEventListener('touchstart', (e) => {
    lastY = e.touches[0].clientY;
});

window.addEventListener('touchmove', scrollMobile);

function scroll(e){
    speedMouse += e.deltaY * 0.02;
}

function scrollMobile(e){
    currY = e.changedTouches[0].clientY;
    if(lastY < currY){
        // Scroll Up
        speedMobile -= (currY-lastY) * 0.1;
    }
    else if(lastY > currY){
        // Scroll Down
        speedMobile += (lastY-currY) * 0.02;
    }
}

function scrolling() {
    speedMouse *= 0.08; // This avoids the event of keep scrolling non-stop
    speedMobile *= 0.04;

    // Scrolling

    if (camera.position.x >= 23) {
        document.getElementById('credits').style.display="block";

        camera.position.x -= -speedMouse;
        camera.position.x += speedMobile;

    } else if (camera.position.x <= -5) {
        camera.position.x = -4.9;

        console.log('reach limit in');

        // camera.position.x += -speedMouse;
        // camera.position.x += speedMobile;

    } else {
        camera.position.x -= -speedMouse;
        camera.position.x += speedMobile;
        document.getElementById('credits').style.display="none";


    }
   
    // Show up the iFrame
    if (camera.position.z < 1.) {
        document.querySelector('canvas.canvasGL').style.display = "none";

        
    } else if(camera.position.z >= 1.) {
        document.querySelector('canvas.canvasGL').style.display = "block";
    }

    window.requestAnimationFrame(scrolling);
}

scrolling();

function gui() {
    // Debug
    const gui = new dat.GUI()
        // let modelFolder = gui.addFolder('3DModel')
        // modelFolder.add(mod.position, 'z', 0, Math.PI * 2)
        // modelFolder.open()
    let camFolder = gui.addFolder('Camera')
    camFolder.add(camera.position, 'x', 0, 10).listen();

    camFolder.add(camera.position, 'y', 0, 10).listen();

    camFolder.add(camera.position, 'z', 0, 10).listen();
    console.log('Camera folder is added')
    camFolder.open()

    let animFolder = gui.addFolder('Anim')
        // animFolder.add(gt, 'x', 0, 10).listen();
        // animFolder.open()
}

// gui();

function allItemsLoaded() {
    $('.onepix-imgloader').fadeOut();
    // fade in content (using opacity instead of fadein() so it retains it's height.
    $('.loading-container > *:not(.onepix-imgloader)').fadeTo(8000, 100);
}

// if(document.getElementById('iframe').style.display == 'block'){
//     console.log('display block')
// }
